export default __webpack_public_path__ + "static/media/RNA_WEB.43fcd97f.svg";